var ProgressBar = function ProgressBar(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/React.createElement("div", {
    className: "progress flex-grow-1",
    style: {
      height: '4px',
      marginLeft: '25px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-bar progress-nurture-green",
    role: "progressbar",
    style: {
      width: "".concat(value, "%")
    },
    "aria-valuenow": value,
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  }));
};
ProgressBar.defaultProps = {
  value: '25'
};
export default ProgressBar;